import React from 'react';
import { motion } from 'framer-motion';
const roadmapSteps = [{
  days: 'Dia 1 ao 7',
  title: 'Auditoria cirúrgica dos seus movimentos bancários para estancar a perda de dinheiro imediata.'
}, {
  days: 'Dia 8 ao 15',
  title: "Configuração das suas '3 Cubetas' de fluxo de caixa para automatizar poupança e gastos fixos."
}, {
  days: 'Dia 16 ao 23',
  title: 'Aplicação do sistema de priorização de dívidas para eliminar juros abusivos.'
}, {
  days: 'Dia 24 ao 30',
  title: 'Criação do hábito de revisão de 5 minutos para o sistema funcionar sozinho, mês após mês.'
}];
export function RoadmapSection() {
  return <section className="bg-navy py-24 px-6 relative overflow-hidden" data-id="element-128">
      <div className="max-w-4xl mx-auto relative z-10" data-id="element-129">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-130">
          <h2 className="font-heading font-bold text-white text-3xl md:text-4xl mb-4" data-id="element-131">
            Sua Transformação em 30 Dias
          </h2>
          <p className="font-body text-orange text-xl font-medium" data-id="element-132">
            Este não é um livro de teoria, é um plano de execução tática.
          </p>
        </motion.div>

        <div className="relative" data-id="element-133">
          {/* Vertical Line */}
          <div className="absolute left-[27px] md:left-1/2 top-0 bottom-0 w-1 bg-navy-dark transform md:-translate-x-1/2 rounded-full" data-id="element-134"></div>

          <div className="space-y-12" data-id="element-135">
            {roadmapSteps.map((step, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-50px'
          }} transition={{
            duration: 0.5,
            delay: index * 0.1
          }} className={`relative flex flex-col md:flex-row items-start md:items-center gap-8 ${index % 2 === 0 ? 'md:flex-row-reverse' : ''}`} data-id="element-136">
                {/* Number Circle */}
                <div className="absolute left-0 md:left-1/2 transform md:-translate-x-1/2 w-14 h-14 bg-orange rounded-full flex items-center justify-center border-4 border-navy shadow-lg z-10 shrink-0" data-id="element-137">
                  <span className="font-heading font-bold text-white text-xl" data-id="element-138">
                    {index + 1}
                  </span>
                </div>

                {/* Content Box */}
                <div className={`ml-20 md:ml-0 w-full md:w-1/2 ${index % 2 === 0 ? 'md:pl-16' : 'md:pr-16 text-left md:text-right'}`} data-id="element-139">
                  <div className="bg-navy-dark p-6 rounded-2xl border border-white/10 shadow-xl hover:border-orange/30 transition-colors duration-300" data-id="element-140">
                    <span className="inline-block font-heading font-bold text-orange text-sm uppercase tracking-wider mb-2" data-id="element-141">
                      {step.days}
                    </span>
                    <p className="font-body text-white/90 leading-relaxed" data-id="element-142">
                      {step.title}
                    </p>
                  </div>
                </div>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}